import React, { useState, useEffect } from "react";
import axios from 'axios';
import {
  Card,
  CardBody,
  Col,
  Row,
  Container,
  Alert,
} from "reactstrap";

// Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

const FormAddUser = () => {
  document.title = "Add Users | Uma Classes";

  const [formData, setFormData] = useState({
    name: "",
    standard: "",
    email: "",
    courses: "", // Store the course ID here
    class: "",
    phoneNumber: "",
    expiryDate: "", // For expiry date
    registrationDate: "", // For registration date
    password: "", // Include password in the state
  });

  const [courses, setCourses] = useState([]); // State to store courses fetched from API
  const [loading, setLoading] = useState(true);
  const [successMessage, setSuccessMessage] = useState(""); // State for success message
  const [errorMessage, setErrorMessage] = useState(""); // State for error message
  const [isSubmitting, setIsSubmitting] = useState(false); // State for form submission loading

  // Fetch only courses on component mount
  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get('https://uma.aasmo.in/api/admin/getall-category', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setCourses(response || []); // Set courses from API response
        setLoading(false);
      } catch (error) {
        console.error("Error fetching courses:", error);
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleCourseChange = (e) => {
    const { value } = e.target;
    if (value) {
      const expiryDate = new Date(); // Set a default expiry date, or you can handle this differently
      setFormData((prevData) => ({
        ...prevData,
        courses: [...prevData.courses, { courseId: value, expiryDate }] // Add courseId and expiryDate
      }));
    }
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true); // Set loading to true when submitting
  
    // Ensure that 'courses' is not empty before submission
    if (formData.courses.length === 0) {
      setErrorMessage("At least one course is required");
      setIsSubmitting(false);
      return;
    }
  
    // Prepare the courses array to include both registrationDate and expiryDate
    const coursesWithDates = formData.courses.map(course => ({
      courseId: course.courseId,
      registrationDate: formData.registrationDate, // Use registrationDate from formData
      expiryDate: formData.expiryDate, // Ensure expiryDate from formData is used for each course
    }));
  
    // Create FormData to send the data, including the image
    const formDataToSend = new FormData();
    formDataToSend.append('name', formData.name);
    formDataToSend.append('email', formData.email);
    formDataToSend.append('phoneNumber', formData.phoneNumber);
    formDataToSend.append('standard', formData.standard);
    formDataToSend.append('class', formData.class);
    formDataToSend.append('password', formData.password);
  
    // Append courses array with registrationDate and expiryDate
    formDataToSend.append('courses', JSON.stringify(coursesWithDates));
  
    // Check if an image is selected and append it to FormData
    const imageInput = document.getElementById('image');
    if (imageInput.files[0]) {
      formDataToSend.append('image', imageInput.files[0]);
    }
  
    console.log(formData.registrationDate, "registrationDate");
    console.log(formData.expiryDate, "expiryDate");
  
    try {
      const token = localStorage.getItem('token');
      await axios.post('https://uma.aasmo.in/api/admin/user-register', formDataToSend, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data', // Specify that we're sending a file
        }
      });
  
      console.log(formDataToSend.get('courses'), "courses payload");
  
      setSuccessMessage("User added successfully");
      setErrorMessage(""); // Clear any previous error messages
  
      // Clear the form fields after successful submission
      setFormData({
        name: "",
        standard: "",
        email: "",
        phoneNumber: "",
        class: "",
        registrationDate: "",
        password: "",
        image: "",
        expiryDate: "",
        courses: [] // Reset the courses array
      });
  
      // Clear file input for image
      if (imageInput) {
        imageInput.value = ''; // Clear the file input
      }
  
    } catch (error) {
      console.error("Error adding user:", error);
      setSuccessMessage(""); // Clear any previous success messages
      setErrorMessage(error.response?.data?.message || "Error adding user"); // Display specific error message
    } finally {
      setIsSubmitting(false); // Set loading to false after submission
    }
  };
  
  
  
  

  
  
  
  

  if (loading) {
    return <div>Loading...</div>; // Optional: add a loading spinner or message
  }


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="Users" breadcrumbItem="Add" />

          <Row>
            <Col>
              <Card>
                <CardBody>
                  <form onSubmit={handleSubmit}>
                    <Row className="mb-3">
                      <label htmlFor="name" className="col-md-2 col-form-label">
                        Full Name
                      </label>
                      <div className="col-md-10">
                        <input
                          className="form-control"
                          type="text"
                          id="name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          required // Add required validation
                        />
                      </div>
                    </Row>
                    <Row className="mb-3">
                      <label htmlFor="email" className="col-md-2 col-form-label">
                        Email
                      </label>
                      <div className="col-md-10">
                        <input
                          className="form-control"
                          type="email"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          required // Add required validation
                        />
                      </div>
                    </Row>
                    <Row className="mb-3">
                      <label htmlFor="phoneNumber" className="col-md-2 col-form-label">
                        Mobile Number
                      </label>
                      <div className="col-md-10">
                        <input
                          className="form-control"
                          type="tel"
                          id="phoneNumber"
                          name="phoneNumber"
                          value={formData.phoneNumber}
                          onChange={handleChange}
                          required // Add required validation
                        />
                      </div>
                    </Row>
                    <Row className="mb-3">
                      <label htmlFor="standard" className="col-md-2 col-form-label">
                        Standard
                      </label>
                      <div className="col-md-10">
                        <input
                          className="form-control"
                          type="text"
                          id="standard"
                          name="standard"
                          value={formData.standard}
                          onChange={handleChange}
                          required // Add required validation
                        />
                      </div>
                    </Row>
                    <Row className="mb-3">
                      <label htmlFor="class" className="col-md-2 col-form-label">
                        Class
                      </label>
                      <div className="col-md-10">
                        <input
                          className="form-control"
                          type="text"
                          id="class"
                          name="class"
                          value={formData.class}
                          onChange={handleChange}
                          required // Add required validation
                        />
                      </div>
                    </Row>
                    <Row className="mb-3">
                      <label htmlFor="courses" className="col-md-2 col-form-label">
                        Courses
                      </label>
                      <div className="col-md-10">
                        <select
                          className="form-control"
                          id="courses"
                          name="courses"
                          onChange={handleCourseChange} // Change event to handle course selection
                          required // Add required validation
                        >
                          <option value="">Select Course</option>
                          {courses.map((course) => (
                            <option key={course._id} value={course._id}>
                              {course.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Row>
                    <Row className="mb-3">
                      <label htmlFor="registrationDate" className="col-md-2 col-form-label">
                        Registration Date
                      </label>
                      <div className="col-md-10">
                        <input
                          className="form-control"
                          type="date"
                          id="registrationDate"
                          name="registrationDate"
                          value={formData.registrationDate}
                          onChange={handleChange}
                          required // Add required validation
                        />
                      </div>
                    </Row>
                    <Row className="mb-3">
                      <label htmlFor="expiryDate" className="col-md-2 col-form-label">
                        Expiry Date
                      </label>
                      <div className="col-md-10">
                        <input
                          className="form-control"
                          type="date"
                          id="expiryDate"
                          name="expiryDate"
                          value={formData.expiryDate}
                          onChange={handleChange}
                          required // Add required validation
                        />
                      </div>
                    </Row>
                    <Row className="mb-3">
                      <label htmlFor="password" className="col-md-2 col-form-label">
                        Password
                      </label>
                      <div className="col-md-10">
                        <input
                          className="form-control"
                          type="password"
                          id="password"
                          name="password"
                          value={formData.password}
                          onChange={handleChange}
                          required // Add required validation
                        />
                      </div>
                    </Row>
                    <Row className="mb-3">
                      <label htmlFor="image" className="col-md-2 col-form-label">
                        Profile Image
                      </label>
                      <div className="col-md-10">
                        <input
                          type="file"
                          className="form-control"
                          id="image"
                          name="image"
                          onChange={handleChange}
                        />
                      </div>
                    </Row>
                    {successMessage && <Alert color="success">{successMessage}</Alert>}
                    {errorMessage && <Alert color="danger">{errorMessage}</Alert>}
                    <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                      {isSubmitting ? "Adding..." : "Add"}
                    </button>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default FormAddUser;
